import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/_topicDetail.module.scss";
import FadeInSection from "../common/FadeInSection";
import Breadcrumb from "../common/breadcrum";
import { useParams } from "react-router-dom";
import { getTopicByDraftKey } from "../../api/topic";
import dayjs from "dayjs";
import { LoadingSpin } from "../LoadingSpin";

const TopicPreviewComponent = () => {
  const { id } = useParams();
  const [topicDetail, setTopicDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchTopicDetail = async (topicId) => {
      if (!topicId) {
        return;
      }
      setIsLoading(true);
      try {
        const topicDetailData = await getTopicByDraftKey(topicId);
        setTopicDetail(topicDetailData);
      } catch (error) {
        alert("トピックの詳細の取得に失敗しました");
      } finally {
        setIsLoading(false);
      }
    };
    fetchTopicDetail(id);
  }, [id]);

  return (
    <div className={styles.topicDetail}>
      {topicDetail && !isLoading && (
        <>
          <div className={styles.top}>
            <FadeInSection>
              <div className={styles.title}>
                {topicDetail.title}
              </div>
              <div className={styles.date}>{dayjs(topicDetail.publishedAt).format("YYYY.MM.DD")}</div>
              <div className={styles.thumbnail}>
                <img src={topicDetail.thumbnail.url} alt="Thumbnail" />
              </div>
            </FadeInSection>
          </div>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: topicDetail.content }} />
        </>
      )}
      {isLoading && (
        <div className={styles.content}>
          <LoadingSpin />
        </div>
      )}
      {!topicDetail && !isLoading && (
        <div className={styles.content}>
          <p>トピックが見つかりませんでした</p>
        </div>
      )}
      <div className={styles.content}>
        <FadeInSection>
          <div className={styles.previos}>
            <a href="/topics">TOPICS LIST</a>
          </div>
        </FadeInSection>
      </div>
      <Breadcrumb
        data={[
          { title: "TOP", link: "/" },
          { title: "TOPICS", link: "/topics" },
          { title: topicDetail?.title, link: `/topicDetail/${topicDetail?.id}` },
        ]}
      />
    </div >
  );
};

export default TopicPreviewComponent;
